/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, volumeText: NonNullable<unknown> }} Wrapped_Period_Calendar_LineInputs */

const en_us2_wrapped_period_calendar_line = /** @type {(inputs: Wrapped_Period_Calendar_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Heaviest day: ${i?.day}, with ${i?.volumeText}.`)
};

const pt_br2_wrapped_period_calendar_line = /** @type {(inputs: Wrapped_Period_Calendar_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O dia mais pesado: ${i?.day}, com ${i?.volumeText}.`)
};

const es_419_wrapped_period_calendar_line = /** @type {(inputs: Wrapped_Period_Calendar_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El día más pesado: ${i?.day}, con ${i?.volumeText}.`)
};

const pt_pt2_wrapped_period_calendar_line = /** @type {(inputs: Wrapped_Period_Calendar_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O dia mais pesado: ${i?.day}, com ${i?.volumeText}.`)
};

const fr_fr2_wrapped_period_calendar_line = /** @type {(inputs: Wrapped_Period_Calendar_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le jour le plus lourd : ${i?.day}, avec ${i?.volumeText}.`)
};

const de_de2_wrapped_period_calendar_line = /** @type {(inputs: Wrapped_Period_Calendar_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schwerster Tag: ${i?.day}, mit ${i?.volumeText}.`)
};

const it_it2_wrapped_period_calendar_line = /** @type {(inputs: Wrapped_Period_Calendar_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il giorno più pesante: ${i?.day}, con ${i?.volumeText}.`)
};

/**
* | output |
* | --- |
* | "Heaviest day: {day}, with {volumeText}." |
*
* @param {Wrapped_Period_Calendar_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_calendar_line = /** @type {((inputs: Wrapped_Period_Calendar_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Calendar_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_calendar_line(inputs)
	if (locale === "es-419") return es_419_wrapped_period_calendar_line(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_calendar_line(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_calendar_line(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_calendar_line(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_calendar_line(inputs)
	return en_us2_wrapped_period_calendar_line(inputs)
});
export { wrapped_period_calendar_line as "wrapped-period.calendar_line" }